import { api } from '../../../services/api/client';

export interface ManualRole { key: string; label: string; color: string; one_liner: string; }
export interface ManualMatrixRow { feature: string; values: Record<string, 'yes' | 'no' | 'limited'>; }
export interface ManualTask { title: string; steps: string[]; }
export interface ManualRoleGuide { role: string; intro: string; can: string[]; cannot: string[]; tasks: ManualTask[]; }
export interface ManualFaq { term: string; desc: string; }

export interface Manual {
  title: string;
  subtitle: string;
  intro: string[];
  roles: ManualRole[];
  role_order: string[];
  matrix_features: ManualMatrixRow[];
  role_guides: ManualRoleGuide[];
  faq: ManualFaq[];
}

export async function adminGetManual(): Promise<Manual> {
  const { data } = await api.get<Manual>('/admin/manual');
  return data;
}

export async function adminDownloadManualPdf(): Promise<Blob> {
  const { data } = await api.get('/admin/manual/pdf', { responseType: 'blob' });
  return data as Blob;
}
